// Shared media helpers for the event / event-history surfaces.
// (Previously copy-pasted at the top of EventList.jsx / EventDetail.jsx /
//  EventItemDetail.jsx.)

/** Make a relative path absolute against the API base. */
export const toAbs = (baseUrl, p) =>
  !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith('/') ? '' : '/'}${p}`;

export const isImage = (f) =>
  f?.mimetype?.startsWith?.('image/') ||
  /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(f?.path || f?.url || f || '');

export const isVideo = (f) =>
  f?.mimetype?.startsWith?.('video/') ||
  /\.(mp4|mov|webm|ogg|avi|mkv)$/i.test(f?.path || f?.url || f || '');

/** Best-effort "cover" media for an event list card. */
export const pickMediaFromEvent = (evt) => {
  const arr = evt?.media || evt?.files || evt?.fileList || [];
  const primary = Array.isArray(arr) ? arr[0] : arr;
  if (primary) return primary;
  return evt?.cover || evt?.image || evt?.image_url || evt?.thumbnail || evt?.banner || null;
};

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const parseDate = (v) => {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(String(v).includes(' ') ? String(v).replace(' ', 'T') : v);
  return Number.isNaN(d.getTime()) ? null : d;
};

/**
 * "September 8, 2026", or "September 8 – September 10, 2026" when the event
 * spans multiple days. Plain text — no time, no locale date strings.
 */
export const formatSpelledDate = (start, end) => {
  const s = parseDate(start);
  const e = parseDate(end);
  if (!s) return '';
  const day = (d) => `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}`;
  const full = (d) => `${day(d)}, ${d.getUTCFullYear()}`;
  const sameDay = e
    && s.getUTCFullYear() === e.getUTCFullYear()
    && s.getUTCMonth() === e.getUTCMonth()
    && s.getUTCDate() === e.getUTCDate();
  if (!e || sameDay) return full(s);
  if (s.getUTCFullYear() === e.getUTCFullYear()) return `${day(s)} – ${full(e)}`;
  return `${full(s)} – ${full(e)}`;
};
